'use strict'

/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// 3rd party
import React, { useState } from 'react'
import { Field } from 'formik'

// walrus
import Text from '../../text'

// lib
import { accessibilityRole } from '../../_support'
import Box from '../../box'
import Pressable from '../../pressable'
import CheckBoxWrapper from '../inputs/checkbox-input/checkbox-wrapper'

export type CheckboxListFieldProps = {
  label?: string
  size?: number
  name: string
  value: string | number
}

export default function CheckboxListField({
  label,
  name,
  size = 20,
  value
}: CheckboxListFieldProps) {
  const [isChecked, setIsChecked] = useState(false)

  const handleToggle = () => {
    setIsChecked(!isChecked)
  }

  return (
    <Box flex='1 1 auto' flexDirection='row' alignItems='center'>
      <Pressable onPress={handleToggle}>
        <Box mr='08'>
          <CheckBoxWrapper isChecked={isChecked} size={size}>
            <Field
              type='checkbox'
              name={name}
              value={value}
              checked={isChecked}
              style={{
                cursor: 'pointer',
                margin: 0,
                height: 'inherit',
                opacity: 0
              }}
            />
          </CheckBoxWrapper>
        </Box>
      </Pressable>
      <Text accessibilityRole={accessibilityRole('label')}>{label}</Text>
    </Box>
  )
}
